if (!customElements.get('check-inventory')) {


  class CheckInventory extends HTMLElement {
    /** @type {Map<string,boolean>} */
    _cache = new Map()
    connectedCallback () {
      /** @type {{ sku: string }} */
      this._currentVariant = { sku: this.getAttribute('data-variant-sku') || '' };
      this._setupEventListeners();
      this._triggerInventoryCheck();
    }

    _setupEventListeners () {
      /** @param {CustomEvent<VariantChangeEventDetail>} e */
      this._onVariantChange = (e) => {
        this._currentVariant = { sku: e.detail?.variant?.sku || '' };
        if (!this._currentVariant.sku) {
          this.style.display = 'none';
          return
        }
        this._triggerInventoryCheck();
      };
      document.addEventListener(theme.events.variantChange, /** @type {EventListener} */(this._onVariantChange));


      this._onVariantOptionsChange = () => this._triggerInventoryCheck();
      document.addEventListener(theme.events.variantOptionsChange, this._onVariantOptionsChange);

      /** @param {MouseEvent} e */
      this._onQtyWrapClick = (e) => {
        const target = /** @type {HTMLElement | null} */ (e.target);
        if (target && target.closest('button')) this._triggerInventoryCheck();
      };
      document.querySelector('.qty-input')?.addEventListener('click', /** @type {EventListener} */(this._onQtyWrapClick));


      this._onQuantityChange = () => this._triggerInventoryCheck();
      document.querySelector('input[name="quantity"]')?.addEventListener('change', this._onQuantityChange);
    }

    disconnectedCallback () {
      // 解绑所有监听器，防止内存泄漏
      if (this._onVariantChange) {
        document.removeEventListener(theme.events.variantChange, /** @type {EventListener} */(this._onVariantChange));
      }
      if (this._onVariantOptionsChange) {
        document.removeEventListener(theme.events.variantOptionsChange, this._onVariantOptionsChange);
      }
      if (this._onQtyWrapClick) {
        document.querySelector('.qty-input')?.removeEventListener('click',/** @type {EventListener} */(this._onQtyWrapClick));
      }
      if (this._onQuantityChange) {
        document.querySelector('input[name="quantity"]')?.removeEventListener('change', this._onQuantityChange);
      }
    }

    async _triggerInventoryCheck () {
      const sku = String(this._currentVariant?.sku || this.getAttribute('data-variant-sku') || '').trim();
      if (!sku) {
        this.style.display = 'none';
        return;
      }

      const quantityRaw = /** @type {HTMLInputElement} */ (document.querySelector('input[name="quantity"]'))?.value;
      const quantity = Number(quantityRaw) || 1;

      /** @type {NodeListOf<HTMLInputElement>} */
      const variantOptionsInputs = document.querySelectorAll('input[id^="product_variant_options_"][type="hidden"]');
      const propertiesValue = Array.from(variantOptionsInputs)
        .map((input) => `${input.id.replace('product_variant_options_', '')}:${input.value}`)
        .join(';');

      const cacheKey = `${sku}-${quantity}-${propertiesValue}`;

      if (this._cache.has(cacheKey)) {
        const hasInventory = /** @type {boolean} */ (this._cache.get(cacheKey));
        this.style.display = hasInventory ? 'flex' : 'none';
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append('sku', sku);
        params.append('quantity', String(quantity));
        params.append('properties', propertiesValue);

        const response = await fetch('https://lampwmsapi.gearun.com/api/Check/CheckOverseasInventoryBySKU', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params.toString(),
        });

        const data = /** @type {{ HasInventory?: boolean }} */ (await response.json());
        const hasInventory = !!(data && data.HasInventory);
        this._cache.set(cacheKey, hasInventory);
        this.style.display = hasInventory ? 'flex' : 'none';
      } catch (error) {
        // console.error('[Inventory Check] Error:', error);
      }
    }

    /**
     * @param {string} sku
     */
    setVariantSku (sku) {
      this._currentVariant = { sku };
      this._triggerInventoryCheck();
    }
  }

  customElements.define('check-inventory', CheckInventory);
}